import { TranslatePipe } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';

import { LocationService, Location, Room } from '../../../../_services';
import { Transition } from '@uirouter/angular';
import { RoomsNamePipe } from '../../../_shared/rooms-name.pipe';

@Component({
    selector: 'location-rooms',
    templateUrl: './room.component.html',
    styleUrls: ['./room.component.scss'],
    providers: [RoomsNamePipe, TranslatePipe],
})
export class RoomComponent implements OnInit {
    @Input() location: Location;

    addingRoom: Room;

    roomSort = (r1, r2) => {
        return r1.id - r2.id;
    };

    constructor(private locationService: LocationService) {}

    ngOnInit() {}

    refreshRooms(): void {
        this.locationService
            .findRoomsById(this.location.id)
            .subscribe((rooms) => {
                this.location.rooms = rooms;
            });
    }

    swapEditing(room: Room): void {
        if (!room['editing']) {
            room['save'] = JSON.parse(JSON.stringify(room));
        }
        room['editing'] = !room['editing'];
    }

    cancelEditing(room: Room): void {
        room.capacity = room['save'].capacity;
        room.name = room['save'].name;
        room.googleCalendarId = room['save'].calendarId;
        room['editing'] = false;
    }

    save(room: Room): void {
        this.locationService
            .saveRoom(this.location, room)
            .subscribe(() => (room['editing'] = false));
    }

    create(): void {
        this.locationService
            .createRoom(this.location, this.addingRoom)
            .subscribe(() => {
                this.addingRoom = null;
                this.refreshRooms();
            });
    }

    displayCreate(): void {
        this.addingRoom = new Room(0, '', 2, 0, false, '', this.location.id);
    }

    remove(room: Room): void {
        this.locationService
            .removeRoom(this.location, room)
            .subscribe(() => this.refreshRooms());
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/directory/location/room/room.component.ts